import { createI18n } from 'vue-i18n';
import zh from './zh';
import en from './en';
import th from './th';

export type LocaleKey = 'zh' | 'en' | 'th';

export const SUPPORTED_LOCALES: LocaleKey[] = ['zh', 'en', 'th'];

export const DEFAULT_LOCALE: LocaleKey = 'zh';

/** 从 URL query 参数 language 中解析合法的语言代码，不合法则回退到默认值 */
export function resolveLocaleFromUrl(): LocaleKey {
  const params = new URLSearchParams(window.location.search);
  const lang = params.get('language') as LocaleKey;
  return SUPPORTED_LOCALES.includes(lang) ? lang : DEFAULT_LOCALE;
}

const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  globalInjection: true, // 全局注入 $t
  locale: resolveLocaleFromUrl(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: { zh, en, th },
});

export default i18n;
